import { Collapse, Flex, Text } from '@chakra-ui/react'
import { notPregnantNote, NotPregnantOption, notPregnantOptions } from '@hb/shared'
import { useCallback, useState } from 'react'
import { useField } from 'react-final-form'
import { useForm } from '../../../FinalForm/FormProvider'
import { useFormWizard } from '../../../FormWizard/context'
import { FormElement } from '../../../Input'
import { useInsuranceInfoStage } from '../InsuranceInfoStageContext'
import { OptionSelectButtons, SelectedOptionView } from './OptionSelectButton'

export const NotPregnant = () => {
  const { readOnly } = useFormWizard()
  const { insuranceInfoData } = useInsuranceInfoStage()
  const option = insuranceInfoData?.option
  const {
    input: { value },
  } = useField('notPregnantOption', { subscription: { value: true } })

  const { change, saveWithoutValidation } = useForm()
  const [loadingOption, setLoadingOption] = useState<NotPregnantOption | null>(null)

  const onChange = useCallback(
    async (updated: NotPregnantOption | null) => {
      change('notPregnantOption', updated)
      if (!updated) return
      setLoadingOption(updated ?? null)
      await saveWithoutValidation(updated !== 'current-plan' && updated !== null)
      setLoadingOption(null)
    },
    [change, saveWithoutValidation],
  )
  return (
    <Collapse unmountOnExit style={{ width: '100%' }} in={option === 'not-pregnant'}>
      <Flex px={1} direction="column" gap={2} py={2}>
        {/* <Box py={2} px={4} bg="white" borderRadius="md" borderWidth="1px" borderColor="gray.200">
          <Text>
            Hamilton Billing is happy to provide you with an assessment, however, please be aware
            that we only provide one free assessment per pregnancy. We recommend patients circle
            back with us when they are pregnant.
          </Text>
        </Box> */}
        <Text px={1} fontWeight={600} lineHeight={1} fontSize="lg" color="gray.600">
          Please specify:
        </Text>
        {value ? (
          <SelectedOptionView
            selected={value}
            options={notPregnantOptions}
            onEditClick={readOnly ? () => {} : () => onChange(null)}
            loading={!!loadingOption}
          />
        ) : !readOnly ? (
          <OptionSelectButtons
            options={notPregnantOptions}
            onSelectOption={onChange}
            loadingOption={loadingOption}
          />
        ) : null}
        <Flex pointerEvents={readOnly ? 'none' : 'auto'}>
          <FormElement name="notPregnantNote" field={notPregnantNote} readOnly={readOnly} />
        </Flex>
      </Flex>
    </Collapse>
  )
}
